import router from './router'
import store from './store'
import { resetRouter } from './router'

const whiteList = ['/login']
let isFetchingRoutes = false

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || '成本核算系统'
  const token = localStorage.getItem('userToken')

  if (token) {
    if (to.path === '/login') {
      // 已登录去登录页，跳转到第一个菜单
      const firstTabPath = store.state.permission.tabRoutes[0]?.path
      next({ path: firstTabPath || '/', replace: true })
      return
    }

    const hasRoutes = store.state.permission.routes && store.state.permission.routes.length > 0
   
    if (hasRoutes) {
      // 有路由了，放行
      next()
    } else if (isFetchingRoutes) {
      // 正在获取，等待
      next(false)
    } else {
      isFetchingRoutes = true
      try {
        resetRouter()
       
        const accessedRoutes = await store.dispatch('permission/GenerateRoutes')
        
        router.addRoutes(accessedRoutes)
        isFetchingRoutes = false
        
        // 关键：获取第一个 Tab 路径
        const firstTab = store.state.permission.tabRoutes[0]
        const redirectPath = firstTab?.path || '/'
        
        // 如果当前是 / 或登录页，跳转到第一个菜单
        // 但不要再进守卫循环，直接放行到目标
        if (to.path === '/' || to.path === '/login') {
          // 直接放行到 redirectPath，不要 next({ path: redirectPath })
          // 因为 redirectPath 已经在路由表里了
          next({ path: redirectPath, replace: true })
        } else {
          next({ ...to, replace: true })
        }
        
      } catch (error) {
        isFetchingRoutes = false
        await store.dispatch('user/Logout')
        next('/login')
      }
    }
  } else {
    // 未登录
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})